const W = 72;
const H = 22;
const PAD = 2;
const R = 3;

const getBatteryColor = (v) => {
  if (v == null) return '#d1d5db';
  if (v >= 70) return '#25A854';
  if (v >= 40) return '#F59E0B';
  return '#EF4444';
};

const BatteryCell = ({ value }) => {
  const pct        = Math.min(Math.max(value ?? 0, 0), 100);
  const color      = getBatteryColor(value);
  const fillW      = Math.max(0, ((W - PAD * 2) * pct) / 100);
  const label      = value != null ? `${value}%` : '—';
  const textOnFill = fillW > W * 0.45;

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <svg
        width={W + 7}
        height={H + 2}
        viewBox={`0 0 ${W + 7} ${H + 2}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Body */}
        <rect
          x={1} y={1}
          width={W} height={H}
          rx={R + 1} ry={R + 1}
          fill="#f3f4f6"
          stroke="#d1d5db"
          strokeWidth={1.5}
        />
        {/* Terminal nub */}
        <rect
          x={W + 1} y={(H - 8) / 2 + 1}
          width={4} height={8}
          rx={1.5} ry={1.5}
          fill="#d1d5db"
        />
        {/* Fill bar */}
        {fillW > 0 && (
          <rect
            x={1 + PAD} y={1 + PAD}
            width={fillW} height={H - PAD * 2}
            rx={R} ry={R}
            fill={color}
          />
        )}
        {/* Label */}
        <text
          x={W / 2 + 1}
          y={H / 2 + 1}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="11"
          fontWeight="500"
          fontFamily="inherit"
          fill={textOnFill ? '#fff' : '#4e535f'}
        >
          {label}
        </text>
      </svg>
    </div>
  );
};

export default BatteryCell;
